import React from 'react';
import {
    Home,
    MyReports,
    NewReportProvider as NewReport,
    Profile,
    QuestionsPage,
    ReportCheckout,
    SignIn
} from '../pages';

import { RouteWithLayout } from '../components/index';
import { EmptyLayout, MainLayout, MinimalLayout } from '../layouts';
import { Router } from '@reach/router';
import { AppRouters } from '../settings';
import PrivateRoute from '../components/router/PrivateRoute';
import AuthRoute from '../components/router/AuthRoute';

export const Routes = (props) => {
    return (
        <Router>
            <RouteWithLayout
                component={SignIn}
                layout={EmptyLayout}
                disabledWhatsapp
                path={AppRouters.signIn}
            />

            <AuthRoute path={AppRouters.auth} />
            <AuthRoute path={AppRouters.confirmWizardReport} redirectTo={AppRouters.continueReportCheckout} />

            <PrivateRoute
                component={Home}
                layout={MinimalLayout}
                path={AppRouters.home}
            />

            <PrivateRoute
                component={NewReport}
                layout={MainLayout}
                path={AppRouters.newReport}
                disabledWhatsapp
            />

            <PrivateRoute
                guestUser={false}
                path={AppRouters.profile}
                component={Profile}
                layout={MainLayout}
                disabledWhatsapp
            />

            <PrivateRoute
                path={AppRouters.myReports}
                component={MyReports}
                layout={MainLayout}
                guestUser={false}
            />

            <PrivateRoute
                path={AppRouters.myReportsError}
                component={MyReports}
                layout={MainLayout}
                guestUser={false}
                disabledWhatsapp
            />

            <PrivateRoute
                path={AppRouters.continueReportCheckout}
                component={ReportCheckout}
                layout={EmptyLayout}
                disabledWhatsapp
            />

            <PrivateRoute
                component={QuestionsPage}
                layout={MainLayout}
                path={AppRouters.questions}
                activeFooter
            />

            <PrivateRoute
                component={Home}
                layout={MinimalLayout}
                default
            />
        </Router>
    );
};

export default Routes;
